import Vue from 'vue'
import App from './App.vue'
import StoryblokVue from 'storyblok-vue'
import VueAnalytics from 'vue-analytics';
import Page from '@/components/Page'
import Hero from '@/components/Heros/AppHero/AppHero.vue'
import Podcasts from "@/components/Podcasts/AppInitPodcasts";
import AddPodcast from "@/components/Podcasts/AppAddPodcast";
import VueAudio from 'vue-audio';
import VueLazyload from 'vue-lazyload'
import AppAbout from "@/components/About/AppAbout";
import Navigation from '@/layouts/navigation/Navigation';
import Footer from '@/layouts/footer/Footer';
import CommingSoon from "@/components/CommingSoon/CommingSoon";
import inViewportDirective from 'vue-in-viewport-directive'
Vue.directive('in-viewport', inViewportDirective)

Vue.component('CommingSoon', CommingSoon)
Vue.component('AppAbout', AppAbout)
Vue.component('Podcasts', Podcasts)
Vue.component('AddPodcast', AddPodcast)
Vue.component('vue-audio', VueAudio)
Vue.component('Hero', Hero)
Vue.component('page', Page)
Vue.component('Navigation', Navigation)
Vue.component('Footer', Footer)
Vue.use(StoryblokVue)
Vue.use(VueLazyload)

// or with options
Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1
})


import forceBreak from "@/helpers/ForceBreak.js";
Vue.prototype.$forceBreak = forceBreak.init


Vue.config.productionTip = false


// Configuration VueAnalytics
Vue.use(VueAnalytics, {
  id: 'UA-168191196-1'
});


new Vue({
  render: h => h(App),
}).$mount('#app')
